<template>
  <v-card
    :max-width="_getMaxWidth()"
    class="update white ma-0 pa-0 pa-5 vetalfa-card-border"
  >
    <v-row class="ma-0 pa-0">
      <v-progress-linear
        class="update-progress ma-0 pa-0"
        background-opacity="0.1"
        rounded
        :value="progress"
      ></v-progress-linear>
    </v-row>
    <v-container fill-height class="ma-0 pa-0 pb-5" style="overflow: hidden">
      <v-row class="ma-0 pa-0 pb-5" align="center" justify="center">
        <v-col cols="12" class="ma-0 pa-0 pb-5">
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <v-img
              position="center"
              class="ma-0 pa-0"
              :max-height="150"
              centered
              contain
              :max-width="230"
              :lazy-src="logo"
              :src="logo"
            ></v-img>
          </v-row>
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <p class="text-center mt-5 ma-0 pa-0 px-2 update-subtitle">
              {{ labels.SLOGAN }}
            </p>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<style>
.update-subtitle {
  color: #004662;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 14px;
}
.update {
  height: 100%;
  width: 100%;
  overflow: hidden !important;
}
.update-progress {
  top: calc(0px + env(safe-area-inset-top));
  width: 100%;
  position: relative;
  z-index: 0;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import images from "@/constants/images.js";
import labels from "@/constants/labels.js";
export default {
  name: "Update",
  components: {},
  computed: {
    ...mapGetters("drugs", ["drugsSummary", "productsSummary"]),
  },
  data() {
    return {
      logo: images.LOGO_BLUE,
      progress: 0,
      progressTimeout: 1,
      labels,
    };
  },
  methods: {
    ...mapActions("general", ["updateApp"]),
    updateData() {
      setTimeout(
        function () {
          if (this.progress > 70) {
            setTimeout(
              function () {
                this.updateApp();
              }.bind(this),
              100
            );
          } else if (this.progress < 90) {
            this.progress += 5;
            this.progressTimeout += 20;
            this.updateData();
          } else {
            this.updateData();
          }
        }.bind(this),
        this.progressTimeout
      );
    },
  },
  created: function () {
    this.updateData();
  },
};
</script>